export default "__VITE_ASSET__3yBBVK$I__"